// TaskActivityLog — modal showing the full history of a task.
// Records: creation, status changes, completion, edits — with who and when.

import React from "react";
import { createPortal } from "react-dom";
import { X, History, Plus, RefreshCw, Pencil, CheckCircle2 } from "lucide-react";
import "../../css/sitevisit/activitylog.css";

const actionMeta = (action) => {
  switch (action) {
    case "created":
      return { icon: <Plus size={13} />, cls: "act-created", label: "Created" };
    case "completed":
      return { icon: <CheckCircle2 size={13} />, cls: "act-created", label: "Completed" };
    case "status_changed":
      return { icon: <RefreshCw size={13} />, cls: "act-status", label: "Status changed" };
    default:
      return { icon: <Pencil size={13} />, cls: "act-updated", label: "Updated" };
  }
};

const fmtTime = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleString("en-IN", {
      day: "numeric", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch (e) {
    return String(d);
  }
};

export default function TaskActivityLog({ log = [], onClose }) {
  const entries = [...log].sort(
    (a, b) => new Date(b.changedAt) - new Date(a.changedAt)
  );

  return createPortal(
    <div className="al-overlay" onClick={onClose}>
      <div className="al-modal" onClick={(e) => e.stopPropagation()}>
        <div className="al-header">
          <h4><History size={16} /> Activity Log</h4>
          <button className="al-close" type="button" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="al-body">
          {entries.length === 0 ? (
            <p className="al-empty">No activity recorded yet.</p>
          ) : (
            <ul className="al-timeline">
              {entries.map((e, i) => {
                const meta = actionMeta(e.action);
                return (
                  <li key={i} className="al-item">
                    <span className={"al-icon " + meta.cls}>{meta.icon}</span>
                    <div className="al-content">
                      <div className="al-line">
                        <strong>{meta.label}</strong>
                        {e.field && e.action !== "created" && (
                          <span className="al-field"> · {e.field}</span>
                        )}
                      </div>
                      {e.action !== "created" && (e.oldValue || e.newValue) && (
                        <div className="al-change">
                          <span className="al-old">{e.oldValue || "—"}</span>
                          <span className="al-arrow">→</span>
                          <span className="al-new">{e.newValue || "—"}</span>
                        </div>
                      )}
                      <div className="al-meta">
                        {e.changedByName || e.changedByEmail || "Unknown"}
                        <span className="al-dot">•</span>
                        {fmtTime(e.changedAt)}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
